export default class FacebookAPI {
  constructor ({ appId = '359143420847165' }) {
    window.fbAsyncInit = () =>
      window.FB.init({
        appId,
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v2.12'
      })

    ;(function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) {return}
      js = d.createElement(s); js.id = id
      js.src = 'https://connect.facebook.net/en_US/sdk.js'
      fjs.parentNode.insertBefore(js, fjs)
    }(document, 'script', 'facebook-jssdk'))
  }

  getStatus () {
    return new Promise(resolve =>
      window.FB.getLoginStatus(({ status }) =>
        status === 'connected' ? resolve(status) : resolve(status)))
  }

  login () {
    return new Promise((resolve, reject) =>
      window.FB.login(({ authResponse, status }) =>
        status === 'connected' ? resolve(authResponse.accessToken) : reject(status)))
  }

  wallPost ({ message, link }) {
    return new Promise((resolve, reject) =>
      window.FB.ui({
        method: 'share',
        href: link,
        quote: message,
      }, ({ error_message: errorMessage, post_id: postId }) =>
        errorMessage ? reject(errorMessage) : resolve(postId))
    )
  }
}



// WEBPACK FOOTER //
// app/javascript/src/services/social/fb.js